// import logo from './logo.svg';
import './App.css'
// import NavBar from "./templates/NavBar";
// import SearchUI from "./templates/Search";
import './modes.css'
import './watched_eye.css'
import NineRoutes from './router'
import { RecoilRoot } from "recoil";
import React from 'react';


function ErrorFallback({ error, resetErrorBoundary }) {
    return (
        <div class="errorMessage">
            <h1>Something went wrong</h1>
            <button type={"button"} onClick={resetErrorBoundary}>Try again</button>
        </div>
    )
}


class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedFromError(error) {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // Error can be logged to an error reporting service
        console.log(error, errorInfo);
    }

    render() {
        console.log(this.state)
        if (this.state.hasError) {
            // You can render any custom Fallback UI
            return <h1>Something went wrong</h1>
        }
        return this.props.children;
    }
}

function App() {
    return (
        // <RecoilRoot>
        <div className="App pct:w-100 pct:h-100">
            {/* <ErrorBoundary fallbackComponent={ErrorFallback}> */}
            <NineRoutes />
            {/* </ErrorBoundary> */}
        </div >
        // </RecoilRoot>
    )
}

export default App
